import { Component, Input } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { AddJobDialogComponent } from '../../../jobs-tab/add-job-dialog/add-job-dialog.component';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-configure-process-button',
    templateUrl: './configure-process-button.component.html',
    styleUrls: ['../styles/common-process-action-button.scss']
})
export class ConfigureProcessButtonComponent {
    constructor(
        private readonly dialog: MatDialog
    ) { }

    ngOnInit(): void {
    }
    @Input()
    public label: string;

    @Input()
    public process: ITaskModel;

    public configureProcess(_event: Event) {
        this.configureJobDialog();
    }

    configureJobDialog() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.minWidth = '50%';
        dialogConfig.maxHeight = '100%';
        dialogConfig.height = 'calc(100% - 30px)'
        dialogConfig.data = this.process;
        const dialogRef = this.dialog.open(AddJobDialogComponent, dialogConfig);
        dialogRef
            .afterClosed()
            .subscribe(() => { });
    }

}
